export const defaultbasicAdsPricingId = '00000000-0000-0000-0000-000000000000';

export const mediaTypeOptions = [
  { label: 'Video', value: 'video' },
  { label: 'Image', value: 'image' },
];
